import React from "react";

export function Button({ children, className = "", variant = "default", ...props }) {
  const baseStyle = "rounded-xl px-4 py-2 text-sm font-medium focus:outline-none transition";
  const variants = {
    default: "bg-red-500 text-white hover:bg-red-600",
    outline: "border border-gray-300 text-red-600 bg-white hover:bg-gray-100",
  };

  return (
    <button className={`${baseStyle} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}
